import React from "react";
import "./ScheduleSkeleton.css";

const ScheduleSkeleton = () => {







  
  // return (
  //   <div className="schedule-inner schedule-skeleton">
  //     {/* === Button Section === */}
  //     <div className="row schedule-btn mb-4">
  //       <div className="col-12">
  //         <div className="skeleton-title"></div>
  //         <div className="skeleton-btn"></div>
  //       </div>
  //     </div>

  //     <div className="row schedule-approve mb-4">
  //       <div className="col-12">
  //         {[...Array(3)].map((_, i) => (
  //           <div className="row skeleton-row mb-2" key={i}>
  //             <div className="col-6">
  //               <div className="skeleton-line short"></div>
  //             </div>
  //             <div className="col-6 text-end">
  //               <div className="skeleton-line long"></div>
  //             </div>
  //           </div>
  //         ))}
  //         <div className="row mt-3">
  //           <div className="col-12">
  //             <div className="skeleton-line medium"></div>
  //             <div className="d-flex align-items-center mt-2 gap-2">
  //               <div className="skeleton-circle"></div>
  //               <div className="skeleton-line long"></div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>

  //     <div className="row schedule-waiting mb-4">
  //       <div className="col-12">
  //         {[...Array(4)].map((_, i) => (
  //           <div className="row skeleton-row mb-2" key={i}>
  //             <div className="col-6">
  //               <div className="skeleton-line short"></div>
  //             </div>
  //             <div className="col-6 text-end">
  //               <div className="skeleton-line long"></div>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </div>

  //     <div className="row schedule-inner2 justify-content-center text-center">
  //       <div className="col-auto">
  //         <div className="skeleton-circle large"></div>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default ScheduleSkeleton;
